( function() {
	const zipFormEle = document.querySelector( '.facility-filters__sort-zip' );
	if( !zipFormEle ){ return; }

	const submitBtnEle = zipFormEle.querySelector( '.facility-filters__sort-zip--submit' );

	const allFilters = document.querySelector( '.facility-filters' );

	submitBtnEle.addEventListener( 'click', submitZip );
	
	zipFormEle.addEventListener( 'keyup', function( e ) {
		if( e.key == 'Enter' ) {
			submitZip.apply( submitBtnEle, arguments );
		}
	} );

	function submitZip( e ) {
		e.preventDefault(); // stop for a sec while we manipulate the URL
		const btn = this;
		const urlStub = btn.dataset.url;
		const splitHashUrl = urlStub.split( '#' );
		const splitParamUrl = splitHashUrl[0].split( '?' );
		const urlParams = new URLSearchParams( splitParamUrl.length > 1 ? splitParamUrl[1] : '' );
		let invalid = false;

		// Collect the value of the zip "form" into a GET request
		const input = btn.closest( '.facility-filters__sort-zip' ).querySelector( 'input' ); 

		if( !input.validity.valid && !input.disabled ) { 
			invalid = true; 
		} 
		else {
			urlParams.set( input.getAttribute( 'name' ), input.value );
		}

		// Clean out any filter values (on the hash) if they're not checked anymore
		if( !invalid ) {
			// Attach the currently selected filters to the zip search
			let validHash = '';
			allFilters.querySelectorAll('input:checked').forEach(function(el) {
				validHash += (validHash.length ? '|' : '') + el.getAttribute('name') + '=' + el.getAttribute('value');
				});

			// recombine the URL and go. Creating a link element to help with relative link resolution
			const aEle = document.createElement( 'a' );
			aEle.href = splitParamUrl[0] + 
				( urlParams.size ? '?' + urlParams.toString() : '' ) +
				( validHash.length ?  '#' + validHash : '' );

			window.location.href = aEle.href;
		}
	}
} )();


